import DataConnectorTool from "./DataConnectorTool";

export default DataConnectorTool;
